<!-- Cancel Modal -->
<div class="modal fade modal--alert"
  id="cancel-policy-alert-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="cancel-policy-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + ( policy?.category_id ? policy?.category_id : policy?.product_category_id  )+ '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closeCancelPolicyAlertModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Before you cancel, did you know you can pause
            your {{entity == 'policy' ? policy?.product_name : item?.description_2}} cover?</h4>
            <p>Don’t need cover for a little while? No problem. Pause your cover and you can resume it at any time.</p>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="#cancel-policy-date-modal" data-toggle="modal" data-dismiss="modal"
          class="button button--lg button--secondary">Cancel Cover</a>
          <!-- <a href="javascript:void(0)"
          (click)="pauseModal.emit(true)"
          data-dismiss="modal"
        class="button button--lg button--primary">Pause Instead</a> -->
      </div>
    </div>
  </div>
</div>
</div>

<!-- Cancel Date Selection -->
<div class="modal fade modal--alert" id="cancel-policy-date-modal" tabindex="-1" role="dialog"
  aria-labelledby="cancel-date-modal"
  aria-modal="true" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closeCancelPolicyDateModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>When would you like to cancel
            your {{entity == entities.Policy ? policy?.product_name : item?.description_2}} cover?</h4>
          </div>
          <div class="form-group mt-30 mb-0">
            <label class="custom-input custom-input--radio custom-input--pill">
              <input
                type="radio"
                name="cancel-date-cover[]"
                [checked]="cancelDateSelection === cancelDateSelectionEnum.Today"
                [value]="cancelDateSelectionEnum.Today"
                [(ngModel)]="cancelDateSelection"
                (ngModelChange)="onDateSelectionChange()">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">From today</span>
              </label>
              <label class="custom-input custom-input--radio custom-input--pill">
                <input
                  type="radio"
                  name="cancel-date-cover[]"
                  [checked]="cancelDateSelection === cancelDateSelectionEnum.EndOfMonth"
                  [value]="cancelDateSelectionEnum.EndOfMonth"
                  [(ngModel)]="cancelDateSelection"
                  (ngModelChange)="onDateSelectionChange()">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">End of this month</span>
                </label>
                <label class="custom-input custom-input--radio custom-input--pill">
                  <input
                    type="radio"
                    name="cancel-date-cover[]"
                    [checked]="cancelDateSelection === cancelDateSelectionEnum.SpecifiedDate"
                    [value]="cancelDateSelectionEnum.SpecifiedDate"
                    [(ngModel)]="cancelDateSelection">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Choose a specific date</span>
                  </label>

                  <div class="mt-15">
                    @if (cancelDateSelection === cancelDateSelectionEnum.SpecifiedDate) {
                      <app-question-date-picker
                        [dateFormat]="'dd/MM/yyyy'"
                        [numberMonths]="1"
                        [minDate]="startMinDate"
                        [showIcon]="true"
                        [category]="policy?.category_id"
                        (questionAnswer)="onDatePickerChange($event)">
                      </app-question-date-picker>
                    }
                  </div>
                  <div class="mt-15">
                    @if (options?.length >0) {
                      <app-question-dropdown
                        [readOnly]="false"
                        [labelText]="'Reason Option'"
                        [question]="null"
                        [showLabel]="true"
                        [options]="options"
                        (questionAnswer)="getReasonID($event)">
                      </app-question-dropdown>
                    }
                  </div>

                  <div class="mt-15">
                    <div class="form-group form-group--lg">
                      <textarea
                        placeholder="Reason for cancellation"
                        [(ngModel)]="responsetext"
                        (blur)="getReasonText()"
                        name="txtReason"
                        rows="5"
                        class="form-control">
                      </textarea>
                    </div>
                    <!-- <app-question-textarea
                    [question]="{question_prompt:'Reason for cancellation', email_version:'Reason for cancellation'}"
                    [readonly]="false"
                    (questionAnswer)="getReasonText($event)">
                  </app-question-textarea> -->
                </div>

              </div>
            </div>
          </div>
          <div class="modal-alert__button">
            <div class="container">
              <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">I'd Rather
              Not</a>
              <a href="javascript:void(0)"
                class="button button--lg button--primary"
                [attr.disabled]="!cancelSelectionDateModalButtonEnabled || !reasonProvided ? true : null"
              (click)="saveCancellationRequest()">Next</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cancel Selection -->
    <div class="modal fade modal--alert" id="cancel-policy-summary-modal" tabindex="-1" role="dialog"
      aria-labelledby="cancel-summary-modal"
      aria-modal="true" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">
          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar">
                <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" (click)="closeCancelPolicySummaryModal()">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </button>
            </div>
          </div>
          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h4>
                  Are you sure you want to cancel your
                  {{
                  entity == entities.Policy ? policy?.product_name :
                  (entity == entities.Vap ? vap?.detail : item?.description_2)
                  }} cover from {{ cancelDateValue | date: 'd MMM yyyy' }}?
                </h4>

              </div>
              <ul class="pause-summary mb-30">
                <li class="pause-summary__item">
                  <div class="pause-summary__label">
                    <p>Your cover will cancel on:</p>
                  </div>
                  <div class="pause-summary__value">
                    <strong>{{cancelDateValue | date: 'd MMM yyyy'}}</strong>
                  </div>
                </li>

              </ul>
              <hr class="hr--bdr hr--sm">
              <div class="note note--naked">
                <div class="note__content" [innerHTML]="refund?.description[0]?.itk">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-alert__button">
            <div class="container">
              <a
                href="javascript:void(0);"
                (click)="removeAction(4)"
                id="cancel-summary-no"
                class="button button--lg button--secondary"
                data-dismiss="modal">
              No, Keep Cover</a>
              <a
                (click)="changeToCancelled()"
                href="javascript:;"
                id="cancel-summary-yes"
                class="button button--lg button--primary"
                >
              Yes, Cancel Cover</a>
            </div>
          </div>
        </div>
      </div>
    </div>
